import styled from 'styled-components'

interface StyledContainerProps {
  $color: string
}

export const StyledContainer = styled.span<StyledContainerProps>`
  font-weight: 600;
  color: ${({ $color }) => $color};
`
